<template>
  <div class="fixedBox">
  <div class="estimateCard  contentCroll">
    <estimation-name
      ref="prediction1"
      :formData="details.prediction"
      :details="details"
      :animalData="animalData"
      @setDetail="setDetail"
    />
    <!-- 经济效益 -->
    <economic-performance
      ref="ipEconomicBenefit"
      :formData="details.ipEconomicBenefit"
      v-if="predictionType == 'growingFinishing'"
    />
    <div class="submitBox">
      <a-button type="primary" @click="estimate"> 立即预估 </a-button>
    </div>
  </div>
  </div>
</template>
<script>
import EstimationName from "./InformationComponents/EstimationName.vue"; // 预估信息
import EconomicPerformance from "./InformationComponents/EconomicPerformance.vue"; // 经济效益
import { mapState, mapMutations } from "vuex";
import { getRequest } from "@/components/Common/Utils/Utils";
import moment from "moment";
export default {
  components: {
    EstimationName,
    EconomicPerformance,
  },
  props: {
    details: {
      type: Object,
      default: () => {
        return {};
      },
    },
    details2:{type: Object,default: () => {return {}}},
    animalData: {
      type: Object,
    },
    animalTypeId: {
      type: String,
    },
    feedProgramId: {
      type: String,
    },
    resEquationId: {
      type: String,
    },
  },
  data() {
    return {
      property: "value",
      arrField: {},
      estimateId: getRequest("id"),
      equationId: "",
      weightData: {},
      pigArr: ["生长猪", "育肥猪", "大猪"],
      weaningArr: ["教槽", "保育前期", "保育后期"],
      animalTypeName: "",
      energyName: "",
      predictionType: "",
      params: JSON.parse(getRequest('params')),
      feedintakeDividedByFeedintakeAndWastage: null
    };
  },
  mounted() {
    this.getInfor();
    if (this.animalTypeId) this.getFeedProcedure(this.animalTypeId);
    this.getRadio()
  },
  computed: {
    ...mapState("estimate", ["dataDictionary"]),
    // feedintakeDividedByFeedintakeAndWastage(){
    //   let {feedIntake} = this.details2 || {}
    //   console.log('feedintakeDividedByFeedintakeAndWastage',this.details2)
    //   let {feedintakeDividedByFeedintakeAndWastage} = feedIntake || {}
    //   return feedintakeDividedByFeedintakeAndWastage
    // },
    pig() {
      // 生长育肥猪
      return this.animalTypeName === "growingFinishing";
    },
    weaning() {
      // 断奶仔猪
      return this.animalTypeName === "startingPigs";
    },
    gestatingSows() {
      // 妊娠母猪
      return this.animalTypeName === "gestatingSows";
    },
    sucklingow(){
      // 哺乳母猪
      return this.animalTypeName === "lactatingSows";
    },
    startWeight(){
      let {weightArr=[]} = this.params || {}
      let startWeight = weightArr[0] ? weightArr[0] : 0
      return startWeight
    },
    endWeight(){
      let {weightArr=[]} = this.params || {}
      let endWeight = weightArr[1] ? weightArr[1] : 0
      return endWeight
    },
    startDay(){
      let {day=[]} = this.params || {}
      let startDay = day[0] ? day[0] : 0
      return startDay
    },
    endDay(){
      let {day=[]} = this.params || {}
      let endDay = day[1] ? day[1] : 0
      return endDay
    },
  },
  watch: {
    details2: {
      handler(){
        this.getRadio()
      },
      deep: true
    },
    details: {
      handler(data) {
        if (data) {
          let { prediction } = data || {};
          let { predictionType } = prediction || {};
          if (predictionType) this.animalTypeName = predictionType;
          this.$emit("getType", predictionType);
        }
      },
      deep: true,
    },
    animalTypeId(val) {
      if (val) {
        this.getFeedProcedure(val);
        this.getPredictionType(val);
      }
    },
  },
  methods: {
    ...mapMutations("economy", ["setEconomyData"]),
    getRadio(){
      let {feedIntake} = this.details2 || {}
      let {feedintakeDividedByFeedintakeAndWastage} = feedIntake || {}
      this.feedintakeDividedByFeedintakeAndWastage = feedintakeDividedByFeedintakeAndWastage
    },
    changeWeight() {
      this.$refs.prediction2 && this.$refs.prediction2.showModal();
    },
    setDetail(val){
      this.details.growthLactating.lactationLength = val
      let {weightRangeFormulaList} = this.details || {}
      let obj = weightRangeFormulaList[0] || {}
      obj.finalDayinput = val
    },
    estimate() {
      let data = this.details;
      let list = ["ipEconomicBenefit"];
      let flag = true;
      let isEstimate = true;
      list.forEach((el) => {
        this.$refs[el] &&
          this.$refs[el].form.validateFields((err, value) => {
            if (err) {
              flag = false;
            } else {
              data[el] = value;
            }
          });
      });

       //经济效益的饲料终端价格
      if (this.$refs.ipEconomicBenefit && this.$refs.ipEconomicBenefit.participate==true && this.$refs.ipEconomicBenefit.feedPriceModel=='FEED_END_USER_PRICE') {
        if (this.$refs.ipEconomicBenefit.feedPriceDays.length === 0) {
          flag = false;
        }
        if (this.$refs.ipEconomicBenefit.feedPriceDays.length >= 1) {
          let length = this.$refs.ipEconomicBenefit.feedPriceDays.length;
          let base = this.$refs.ipEconomicBenefit.feedPriceDays[length - 1];
          if (this.pig) {
            if (base.price == null ||base.price == "") {
              this.$message.warning("请完善饲料终端价格");
              isEstimate = false;
            } else {
              data.ipEconomicBenefit.feedPriceDays =this.$refs.ipEconomicBenefit.feedPriceDays || []; 
            }
          }
        }
      }

      if (!flag) {
        this.$message.warning("请完善输入内容");
        return;
      }
      if (!data.prediction) data.prediction = {};
     
      data.prediction.feedProgramId = this.feedProgramId;
      data.prediction.equationId = this.resEquationId;
      data.prediction.predictionType = this.animalTypeName;
      data.prediction.varietyId = this.animalData.varietyId;
      data.prediction.name =
        moment(new Date()).format("YYYYMMDD") +
        "_" +
        this.animalData.animalTypeName;
      data.prediction.feedingName =
        moment(new Date()).format("YYYYMMDD") +
        "_" +
        this.animalData.animalTypeName;
      data.prediction.customerId = window.localStorage.getItem("customerId");
      data.prediction.animalTypeId = this.animalData.animalTypeId;
      data.prediction.applyTo = "NHF";
      if (data.ipEconomicBenefit) {
        this.setEconomyData(data.ipEconomicBenefit.participate);
      }
      if(this.pig){
        data.weightRangeFormulaList[0]={initialBwforaa:this.startWeight,finalBwforaa:this.endWeight}
      }
      if(this.gestatingSows){
        data.weightRangeFormulaList[0]={initialDayinput:this.startDay,finalDayinput:this.endDay}
        
      }
      if(data.feedIntake){
        data.feedIntake.feedintakeDividedByFeedintakeAndWastage = (this.feedintakeDividedByFeedintakeAndWastage || 0)
      }
      

      let url = "";
      if (this.pig) url = "/sat-maximization/prediction/savePredictionInfo";
      if (this.weaning) url = "/sat-maximization/prediction/savePredictionInfoForWeanedPiglets";
      if (this.gestatingSows) url='/sat-maximization/prediction/savePredictionInfoForGestation';
      if (this.sucklingow) url='/sat-maximization/prediction/savePredictionInfoForLactating';
      //  console.log( isEstimate,url);
      //预估
      if(isEstimate){
        this.$http
        .post(url, data)
        .then((res) => {
          let { success, data, msg } = res;
          if (success) {
            let { id } = data || {};
            this.$message.success("预估成功");
            this.$emit("getId", id);
          } else {
             this.$message.error(msg);
          }
        })
        .catch(() => {
          this.$message.error("预估失败");
        });
      } 
    },
    resetFields() {
      if (!this.equationId) return;
      this.$http
        .get(
          `/sat-maximization/ipdefaultvalue/listByEquationId?equationId=${this.equationId}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            if (data && data.length > 0) {
              let details = {};
              data.forEach((el) => {
                let str = el.keyName.split(".");
                if (str.length > 0) {
                  let key1 = str[0].replace(str[0][0], str[0][0].toLowerCase());
                  let key2 = str[1];
                  if (!details[key1]) details[key1] = {};
                  let val = "";
                  if (el.keyValue === "true") {
                    val = true;
                  } else if (el.keyValue === "false") {
                    val = false;
                  } else {
                    val = el.keyValue;
                  }
                  details[key1][key2] = val;
                }
              });
              this.details = details;
            } else {
              this.$message.warning("该饲喂程序没有默认数据");
            }
          }
        });
    },
    getInfor() {
      this.equationId = getRequest("id");
    },
    getFeedProcedure(animalTypeId) {
      if (!animalTypeId) return;
      let params = {
        animalTypeId,
      };
      this.$http
        .get("/sat-maximization/predictiontype/predictionTypeByAnimalTypeId", {
          params,
        })
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            let { predictionTypeCode: predictionType } = data || {};
            if (predictionType) {
              this.$emit("getType", predictionType);
              this.animalTypeName = predictionType;
            }
          }
        });
    },
    feedProcedure(data) {
      let { feedingProgramId, equationId, animalTypeName, predictionTypeCode } =
        data || {};
      this.animalTypeName = predictionTypeCode;
      this.equationId = equationId;
      this.$emit("getType", predictionTypeCode);
      this.getFeedProcedure(feedingProgramId);
      setTimeout(() => {
        this.$refs.prediction1 &&
          this.$refs.prediction1.setName(animalTypeName);
        this.$refs.growthPerformance && this.$refs.growthPerformance.init(data);
        this.$refs.EconomicPerformance &&
          this.$refs.EconomicPerformance.setEquationId(data);
      }, 100);
    },
    getEnergySystemName(name) {
      this.energyName = name;
    },

    // 根据动物类型查询predictionType
    getPredictionType(id) {
      this.$http
        .get(
          `/sat-maximization/predictiontype/predictionTypeByAnimalTypeId?animalTypeId=${id}`
        )
        .then((res) => {
          let { success, data } = res || {};
          if (success) {
            this.predictionType = data.predictionTypeCode;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.setInfo {
  max-height: 92vh;
  overflow-y: scroll;
}
.fixedBox{
  /* margin-bottom: 65px; */
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.estimateCard{
 padding-bottom: 60px;
}
.fixedBottom{
  position: absolute;
  z-index: 999;
  bottom: 0;
  width:97%;
  box-shadow: 0 -1px 3px 0 rgb(230, 230, 230);
  background-color: #fff;
}
</style>